import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import DataWrapperChart from 'components/datawrapper'
import Dots from './dots'
import {
  ScrollContainer,
  GraphsContainer,
  DataWrapperContainer,
} from './styled'
const ScrollGraphs = () => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start start', 'end end'],
  })

  const activeIndex = useTransform(
    scrollYProgress,
    [0, 0.25, 0.5, 0.75, 1],
    [0, 1, 2, 3, 3]
  )

  const opacity0 = useTransform(activeIndex, (v) =>
    Math.round(v) === 0 ? 1 : 0
  )
  const opacity1 = useTransform(activeIndex, (v) =>
    Math.round(v) === 1 ? 1 : 0
  )
  const opacity2 = useTransform(activeIndex, (v) =>
    Math.round(v) === 2 ? 1 : 0
  )
  const opacity3 = useTransform(activeIndex, (v) =>
    Math.round(v) === 3 ? 1 : 0
  )
  const zIndex0 = useTransform(activeIndex, (v) =>
    Math.round(v) === 0 ? 2 : 1
  )
  const zIndex1 = useTransform(activeIndex, (v) =>
    Math.round(v) === 1 ? 2 : 1
  )
  const zIndex2 = useTransform(activeIndex, (v) =>
    Math.round(v) === 2 ? 2 : 1
  )
  const zIndex3 = useTransform(activeIndex, (v) =>
    Math.round(v) === 3 ? 2 : 1
  )
  const x0 = useTransform(activeIndex, (v) => {
    if (Math.round(v) === 0) return '0%'
    if (Math.round(v) < 0) return '10%'
    return '-10%'
  })
  const x1 = useTransform(activeIndex, (v) => {
    if (Math.round(v) === 1) return '0%'
    if (Math.round(v) < 1) return '10%'
    return '-10%'
  })
  const x2 = useTransform(activeIndex, (v) => {
    if (Math.round(v) === 2) return '0%'
    if (Math.round(v) < 2) return '10%'
    return '-10%'
  })
  const x3 = useTransform(activeIndex, (v) => {
    if (Math.round(v) === 3) return '0%'
    if (Math.round(v) < 3) return '10%'
    return '-10%'
  })
  return (
    <ScrollContainer ref={containerRef}>
      <GraphsContainer>
        <motion.div
          style={{
            width: '100%',
            opacity: opacity0,
            zIndex: zIndex0,
            x: x0,
            transition: 'all .3s',
          }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
        >
          <DataWrapperContainer>
            <DataWrapperChart
              nomargin={true}
              title="Глобальный индекс мира и безопасности женщин за 2023 год"
              ariaLabel="Table"
              id="datawrapper-chart-L273O"
              src="https://datawrapper.dwcdn.net/L273O/5/"
              height="437px"
            />
            <Dots id={0} />
          </DataWrapperContainer>
        </motion.div>
        <motion.div
          style={{
            width: '100%',
            opacity: opacity1,
            zIndex: zIndex1,
            x: x1,
            transition: 'all .3s',
          }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        >
          <DataWrapperContainer className="right">
            <DataWrapperChart
              nomargin={true}
              title="За последние годы в Кыргызстане растет число случаев домашнего насилия"
              ariaLabel="Interactive line chart"
              id="datawrapper-chart-htCNh"
              src="https://datawrapper.dwcdn.net/htCNh/4/"
              height="425px"
            />
            <Dots id={1} />
          </DataWrapperContainer>
        </motion.div>
        <motion.div
          style={{
            width: '100%',
            opacity: opacity2,
            zIndex: zIndex2,
            x: x2,
            transition: 'all .3s',
          }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
        >
          <DataWrapperContainer className="right">
            <DataWrapperChart
              nomargin={true}
              title="В Казахстане ежегодно растет количество защитных предписаний и особых требований"
              ariaLabel="Split Bars"
              id="datawrapper-chart-MvwS0"
              src="https://datawrapper.dwcdn.net/MvwS0/7/"
              height="384px"
            />
            <Dots id={2} />
          </DataWrapperContainer>
        </motion.div>
        <motion.div
          style={{
            width: '100%',
            opacity: opacity3,
            zIndex: zIndex3,
            x: x3,
            transition: 'all .3s',
          }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
        >
          <DataWrapperContainer className="right">
            <DataWrapperChart
              nomargin={true}
              title="В Узбекистане большинство охранных ордеров выдавались от насилия в семье"
              ariaLabel="Donut Chart"
              id="datawrapper-chart-0mTSn"
              src="https://datawrapper.dwcdn.net/0mTSn/7/"
              height="500px"
            />
            <Dots id={3} />
          </DataWrapperContainer>
        </motion.div>
      </GraphsContainer>
    </ScrollContainer>
  )
}
export default ScrollGraphs
